import React, { useEffect, useState, useContext, useMemo } from 'react';
import { Card, CardBody, Col, Row } from "reactstrap";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as ActiveControl } from "../../../../../../assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveControl } from "../../../../../../assets/img/svg/InactiveControl.svg";
// import { endpoint } from 'views/pages/manage/common/constant';
import { endpoint, pages } from '../../../common/constant';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import CustomLoader from 'views/pages/manage/common/commonComponents/Loader/loader';
import { DesktopTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { timepickerStyle } from '../../../academicPlanAndTest/academicTimetable/lectureModule/AddLectureModalForm';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { PermissionContext, RolePermissions } from "../../../../../../appContext";
import { checkPermission } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { PermisionDenied } from "../../../common/commonComponents";
import { DisplayViewData, getAuditDetails } from './common';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { contactDetail, FRANCHISE_EMAIL_COLUMN, tabFilledHandler } from './constant';
import { dropdownMapping } from 'views/pages/manage/unAssigned/studentCharges/common';

var _ = require('lodash');

const grievanceLevels = ["L1", "L2", "L3"];

const weekdays = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" }
];

const ContactDetailsForm = ({
    selectedTabValue,
    buId,
    action,
    contactDetails, fetchLocationAndContactDetails = () => { },
    contactDetailsFetching,
    isEdit,
    setIsEdit,
    setFilled,
    basicDetail,
}) => {

    const EMPTY_FORM = {
        id: '',
        contactName: '',
        emailId: '',
        urlAddress: '',
        status: 'ACTIVE',
        contactNumbers: '',
        startTime: '',
        endTime: '',
        weekOffDays: [],
        centerEmailId: '',
        grievanceInfo: {
            "L1": {},
            "L2": {},
            "L3": {}
        }
    }


    const permissions = useContext(PermissionContext);
    const userPermissions = RolePermissions(permissions, pages['businessAreaContactDetails']['id']);
    const isUpdatePermission = checkPermission(userPermissions, 'U');
    const isCreatePermission = checkPermission(userPermissions, 'C');

    const [form, setForm] = useState(EMPTY_FORM);
    const [isFormDisabled, setIsFormDisabled] = useState(false);
    const [inValidDataInfo, setInValidDataInfo] = useState({});
    const [isMandatoryDetailOpen, setIsMandatoryDetailOpen] = useState(true)
    const [isL1Open, setIsL1Open] = useState(true)
    const [isL2Open, setIsL2Open] = useState(true)
    const [isL3Open, setIsL3Open] = useState(true)
    const [prevData, setPrevData] = useState({})
    const [dropdowns, setDropdowns] = useState({})


    const formHandler = (value, key) => {
        setForm(prev => ({ ...prev, [key]: value }));
    }

    const grievanceInfoChangeHandler = (level, value, key) => {
        console.log('value', value)
        setForm(prev => {
            const grievanceObj = { ...prev?.grievanceInfo[level] }
            grievanceObj[key] = value;
            return {
                ...prev,
                grievanceInfo: {
                    ...prev.grievanceInfo,
                    [level]: grievanceObj
                }
            }
        })
    }

    useEffect(() => {

        if (dropdowns?.roleName && (action === 'edit' || action === 'view')) {
            setIsFormDisabled(true);
            setInValidDataInfo({});
            const {
                contactId,
                contactName,
                emailId,
                urlAddress,
                status,
                contactNumbers,
                startTime,
                endTime,
                weekOffDays,
                centerEmailId,
                grievanceMappingDTOList,
                franchiseEmail
            } = contactDetails ?? {};
            setForm({
                ...EMPTY_FORM,
                id: contactId,
                contactName,
                emailId,
                urlAddress,
                status,
                startTime: startTime ?? form?.startTime,
                endTime: endTime ?? form?.endTime,
                contactNumbers,
                centerEmailId,
                franchiseEmail,
                weekOffDays: weekOffDays?.split(',')?.map(el => (el)) ?? [],
                grievanceInfo: getGrievanceInfoObj(grievanceMappingDTOList ?? [], dropdowns?.roleName)
            })
        }

    }, [contactDetails, dropdowns?.roleName])
    const getDropdowns = async () => {
        const p = await dropdownMapping(endpoint.role_Name.getAllActive, 'roleName')
        setDropdowns({ roleName: p })
    };
    useEffect(() => {
        getDropdowns()
    }, [])


    const getGrievanceInfoArr = () => {
        const grievanceInfoFormObj = form?.grievanceInfo;
        const arr = Object.keys(grievanceInfoFormObj).map(level => ({
            grievanceType: level,
            ...grievanceInfoFormObj[level],
            roleName: grievanceInfoFormObj[level]?.roleName?.label
        }))

        return arr;
    }

    const getGrievanceInfoObj = (grievanceMappingDTOList, roleList = []) => {
        const obj = EMPTY_FORM?.grievanceInfo;
        grievanceMappingDTOList.forEach(el => {
            obj[el?.grievanceType] = { ...el, roleName: roleList.find(item => item?.label == el?.roleName) };
        })
        return obj;
    }

    const validateFranchiseEmail = (emailString) => {
        // Trim and check if empty
        const trimmedEmail = emailString?.trim();
        if (!trimmedEmail) {
            return { valid: false, message: "Franchise Email is mandatory and cannot be left blank!" };
        }

        // Split by comma and trim each email
        const emails = trimmedEmail.split(',').map(email => email.trim()).filter(email => email);

        // Check maximum 4 emails allowed
        if (emails.length > 4) {
            return { valid: false, message: "Maximum 4 franchise emails allowed! You have entered " + emails.length + " emails." };
        }

        // Validate each email
        for (let i = 0; i < emails.length; i++) {
            const email = emails[i];

            // Check if email is empty after trim
            if (!email) {
                return { valid: false, message: "Franchise Email cannot be empty!" };
            }

            // Check for exactly one @ symbol
            if ((email.match(/@/g) || []).length !== 1) {
                return { valid: false, message: "Franchise Email must contain exactly one '@' symbol. Email " + (i + 1) + ": " + email };
            }

            // Check for consecutive special characters (..)
            if (email.includes('..')) {
                return { valid: false, message: "Franchise Email should not contain consecutive special characters (e.g. ..). Email " + (i + 1) + ": " + email };
            }

            // Check if starts or ends with special characters (. or -)
            if (email.startsWith('.') || email.startsWith('-') || email.endsWith('.') || email.endsWith('-')) {
                return { valid: false, message: "Franchise Email should not start or end with special characters (. or -). Email " + (i + 1) + ": " + email };
            }

            // Split email into local and domain parts
            const [localPart, domainPart] = email.split('@');

            if (!localPart || !domainPart) {
                return { valid: false, message: "Invalid franchise email format.Franchise Email " + (i + 1) + ": " + email };
            }

            // Check if domain contains at least one dot
            if (!domainPart.includes('.')) {
                return { valid: false, message: "Domain name must include at least one dot (.) and a valid domain extension. Franchise Email " + (i + 1) + ": " + email };
            }

            // Check if domain is valid (must be aesl.in)
            if (!domainPart.toLowerCase().endsWith('aesl.in')) {
                return { valid: false, message: "Valid domain is aesl.in. Franchise Email " + (i + 1) + ": " + email };
            }

            // Check local part format (alphanumeric, dots, hyphens, underscores allowed)
            const localPartRegex = /^[a-zA-Z0-9._-]+$/;
            if (!localPartRegex.test(localPart)) {
                return { valid: false, message: "Franchise Email contains invalid characters. Franchise Email " + (i + 1) + ": " + email };
            }

            // Additional check for standard email format
            const fullEmailRegex = /^[a-zA-Z0-9._-]+@aesl\.in$/;
            if (!fullEmailRegex.test(email)) {
                return { valid: false, message: "Invalid franchise email format. Franchise Email " + (i + 1) + ": " + email };
            }
        }

        return { valid: true, message: "Valid" };
    }

    const saveHandler = async () => {
        const employeeIdRegex = new RegExp(/^AESL-[AF]\d{1,6}$/);
        const emailRegex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);
        const mobNoRegex = new RegExp(/^\d{10}$/);
        const stateCodeAndExtensionRegex = new RegExp(/^\d{6}$/);

        if (!employeeIdRegex.test(form?.id.trim())) {
            failureToast("Please Enter Valid Employee ID!");
            setInValidDataInfo({ field: 'id' })
            return;
        }

        if (!emailRegex.test(form.emailId.trim())) {
            failureToast("Please Enter Valid Email ID!");
            setInValidDataInfo({ field: 'emailId' })
            return;
        }
        if (!emailRegex.test(form.centerEmailId.trim())) {
            failureToast("Please Enter Valid Center Email ID!");
            setInValidDataInfo({ field: 'centerEmailId' })
            return;
        }
        
        // Validate franchise email when business unit type is Franchise or SubContractor
        if ([ 'Franchise', 'SubContractor' ].includes(basicDetail?.businessUnitType?.[0]?.label)) {
            const franchiseEmailValidation = validateFranchiseEmail(form?.franchiseEmail);
            if (!franchiseEmailValidation.valid) {
                failureToast(franchiseEmailValidation.message);
                setInValidDataInfo({ field: 'franchiseEmail' })
                return;
            }
        }

        let isGrievanceInfoInvalid = false;

        Object.keys(form?.grievanceInfo).forEach(level => {
            const grievanceObj = form?.grievanceInfo[level];
            const emailId = grievanceObj?.emailId;
            const contactNumber = grievanceObj?.contactNumber;

            if (emailId && !emailRegex.test(emailId?.trim())) {
                failureToast("Please Enter Valid Email ID!");
                setInValidDataInfo({ level: level, field: 'emailId' })
                isGrievanceInfoInvalid = true;
                return;
            }
            if (contactNumber && !mobNoRegex.test(contactNumber?.trim())) {
                failureToast("Please Enter Valid Contact Number!");
                setInValidDataInfo({ level: level, field: 'contactNumber' });
                isGrievanceInfoInvalid = true;
                return;
            }


        })

        if (isGrievanceInfoInvalid) return;


        setInValidDataInfo({})

        const reqObj = {
            contactName: form?.contactName,
            contactId: form?.id,
            businessAreaId: buId,
            status: form?.status || 'ACTIVE',
            emailId: form?.emailId,
            urlAddress: form?.urlAddress,
            contactNumbers: form?.contactNumbers,
            startTime: form?.startTime,
            endTime: form?.endTime,
            weekOffDays: form?.weekOffDays?.map(el => el).join(","),
            grievanceMappingDTOList: getGrievanceInfoArr(),
            centerEmailId: form?.centerEmailId,
            franchiseEmail: form?.franchiseEmail?.split(',')?.map(el => el.trim()).filter(Boolean).join(',')
        }

        let url = endpoint.contactDetails.create;
        let method = 'post';
        if (contactDetails?.id) {
            url = `${endpoint.contactDetails.update}/${contactDetails?.id}`;
            method = 'put'
        }

        const resp = await fetchAllPostPromisedData(url, reqObj, method);
        if (resp?.code === 200) {
            fetchLocationAndContactDetails();
            successToast('Request completed successfully!');
            //fetchLocationAndContactDetails()
            setIsEdit(false)
            action == 'new' && tabFilledHandler(setFilled, 'contactDetail', true)
        }
    }

    function allMandatoryFieldsEntered() {

        const hasEmptyField = (field) => {
            console.log('field:', field);

            let isEmpty;

            if (Array.isArray(field)) {
                isEmpty = field.length === 0;
            } else if (_.isObject(field)) {
                isEmpty = !field?.value?.trim();
            } else {
                isEmpty = !field?.trim?.(); // safe for strings
            }

            console.log('isEmpty:', isEmpty);
            return isEmpty;
        };

        const topLevelMandatoryFields = ['id', 'contactName', 'emailId', 'startTime', 'endTime', 'contactNumbers', 'centerEmailId', 'urlAddress', 'weekOffDays'];
        if (topLevelMandatoryFields.some(field => (hasEmptyField(form[field])))) {
            return false;
        }

        if (Array.isArray(form?.weekOffDays) && form?.weekOffDays?.length === 0) return false;

        // const phoneNumberMandatoryFields = ['type', 'number'];
        // if (form.contactNumbers.some(phoneNumber => phoneNumberMandatoryFields.some(field => hasEmptyField(phoneNumber[field])))) {
        //     return false;
        // }

        // Check if franchiseEmail is mandatory when business unit type is Franchise or SubContractor
        if ([ 'Franchise', 'SubContractor' ].includes(basicDetail?.businessUnitType?.[0]?.label)) {
            if (hasEmptyField(form?.franchiseEmail)) {
                return false;
            }
        }

        let grievanceInfoMandatoryFieldsEntered = true

        Object.keys(form?.grievanceInfo).forEach(level => {
            const grievanceObj = form?.grievanceInfo[level];
            if (!grievanceObj?.roleName?.value) {
                grievanceInfoMandatoryFieldsEntered = false;
                return false;
            }

        })

        if (!grievanceInfoMandatoryFieldsEntered) return false;




        return true;
    }
    const editHandler = () => {
        if (isEdit) {
            failureToast(saveOrDeleteMsg)
        }
        else {
            setIsEdit(true)
            setPrevData(form)
        }
    }
    const cancelHandler = () => {
        setForm(prevData)
        setIsEdit(false)
    }
    useEffect(() => {// check if tab details are filled  or not
        const checkFilled = () => {
            if (contactDetails?.contactName) {
                tabFilledHandler(setFilled, 'contactDetail', true)
            }
            else {
                tabFilledHandler(setFilled, 'contactDetail', false)
            }
        }
        action == 'edit' && checkFilled()

    }, [contactDetails])
    useEffect(() => {
        selectedTabValue?.key == 'contactDetail' && fetchLocationAndContactDetails()
    }, [selectedTabValue?.key])


//     useEffect(() => {
//   if (basicDetail?.buAreaType !== 'franchise') {
//     setFormData(prev => ({
//       ...prev,
//       franchiseEmail: '',
//     }));
//   }
// }, [basicDetail?.businessUnitType?.label]);

const mandatoryColumns = useMemo(() => {
  const cols = [...contactDetail?.mandatoryDetail];

    if ([ 'Franchise', 'SubContractor' ].includes(basicDetail?.businessUnitType?.[0]?.label)) {
        cols.push(FRANCHISE_EMAIL_COLUMN);
    }

  return cols;
}, [basicDetail?.businessUnitType?.[0]?.label]);



    if (selectedTabValue?.id != 3) return null;


    return (

        userPermissions ?

            <LocalizationProvider dateAdapter={AdapterMoment}>
                <div className='w-100' onClick={() => setInValidDataInfo({})}>
                    {contactDetailsFetching ? <CustomLoader /> :

                        <>


                            <Card className='ml-0'>
                                <CardBody>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div className='large-text color-grey-80'>Contact Details</div>
                                        <div className='d-flex align-items-center justify-content-center'>
                                            <div className='d-flex'>
                                                <h4 className='mr-2'>Status : </h4>
                                                {form?.status === "ACTIVE" ?
                                                    <span onClick={() => !isFormDisabled && formHandler("INACTIVE", "status")}><ActiveControl /> Active</span> :
                                                    <span onClick={() => !isFormDisabled && formHandler("ACTIVE", "status")}><InactiveControl /> Inactive</span>
                                                }
                                            </div>
                                            {action != 'view' ? action == 'new' ?
                                                <AButton
                                                    variant="primary_filled"
                                                    onClick={e => {

                                                        saveHandler();
                                                    }}
                                                    disabled={!allMandatoryFieldsEntered()}
                                                >
                                                    Save
                                                </AButton>

                                                :
                                                (!isEdit) ? <AButton
                                                    variant="outline"
                                                    // className="w-full"
                                                    onClick={() => {
                                                        editHandler()
                                                    }}
                                                    disabled={!isUpdatePermission}
                                                //    size='xs'
                                                >
                                                    Edit
                                                </AButton>
                                                    : <div> <AButton
                                                        variant="primary_filled"
                                                        // className="w-full"
                                                        onClick={saveHandler}
                                                        disabled={(action === 'new' && !isCreatePermission) || !allMandatoryFieldsEntered()}
                                                    >
                                                        Save changes
                                                    </AButton>
                                                        <AButton
                                                            variant="danger_filled"
                                                            // className="w-full"
                                                            onClick={cancelHandler}
                                                        //disabled={(action === 'new' && !isCreatePermission) || !allMandatoryFieldsEntered()}
                                                        >
                                                            Cancel
                                                        </AButton>
                                                    </div> : <></>}
                                        </div>
                                    </div>
                                    <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>

                                    <DisplayViewData
                                        dataArray={mandatoryColumns?? []}
                                        heading='Mandatory details'
                                        isEdit={isEdit || action == 'new'}
                                        action={action}
                                        rowFormHandler={(key, val) => {
                                            setForm({
                                                ...form,
                                                [key]: val
                                            })
                                        }}
                                        form={form}
                                        setForm={setForm}
                                        openToggle={isMandatoryDetailOpen}
                                        setOpenToggle={setIsMandatoryDetailOpen}
                                        toggleRequired
                                    //dropdown={geoData}
                                    />
                                    <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                                    <DisplayViewData
                                        dataArray={contactDetail?.l1Grievance ?? []}
                                        heading='L1 grievances'
                                        isEdit={isEdit || action == 'new'}
                                        action={action}
                                        rowFormHandler={(key, val) => {
                                            grievanceInfoChangeHandler('L1', val, key)
                                        }}
                                        form={form.grievanceInfo['L1']}
                                        setForm={setForm}
                                        openToggle={isL1Open}
                                        setOpenToggle={setIsL1Open}
                                        toggleRequired
                                        dropdown={dropdowns}
                                    />
                                    <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                                    <DisplayViewData
                                        dataArray={contactDetail?.l2Grievance ?? []}
                                        heading='L2 grievances'
                                        isEdit={isEdit || action == 'new'}
                                        action={action}
                                        rowFormHandler={(key, val) => {
                                            grievanceInfoChangeHandler('L2', val, key)
                                        }}
                                        form={form.grievanceInfo['L2']}
                                        setForm={setForm}
                                        openToggle={isL2Open}
                                        setOpenToggle={setIsL2Open}
                                        toggleRequired
                                        dropdown={dropdowns}
                                    />
                                    <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                                    <DisplayViewData
                                        dataArray={contactDetail?.l3Grievance ?? []}
                                        heading='L3 grievances'
                                        isEdit={isEdit || action == 'new'}
                                        action={action}
                                        rowFormHandler={(key, val) => {
                                            grievanceInfoChangeHandler('L3', val, key)
                                        }}
                                        form={form.grievanceInfo['L3']}
                                        setForm={setForm}
                                        openToggle={isL3Open}
                                        setOpenToggle={setIsL3Open}
                                        toggleRequired
                                        dropdown={dropdowns}
                                    />
                                    {(action === 'view' || action === 'edit') && contactDetails && getAuditDetails(contactDetails?.updatedBy, contactDetails?.updatedOn)}
                                </CardBody>
                            </Card>

                        </>

                    }

                </div>
            </LocalizationProvider>

            : <PermisionDenied />

    );
}

export default ContactDetailsForm;